<script lang="ts">
  import { createContext } from 'reka-ui'
  import type { CurrenciesService } from '@gat-ship/types/injection-keys'
  import type { useCurrencySignalREvents } from '@gat-ship/signalr'

  /**
   * The concrete data-source shape. The runtime-free `CurrenciesService`
   * contract intentionally omits `signalR` (a `@gat-ship/signalr` value-type),
   * but the concrete `useCurrencies` result always carries it and
   * `CurrenciesView` drives the subscription through this reka-ui context.
   */
  type CurrenciesDataSource = CurrenciesService & {
    signalR: ReturnType<typeof useCurrencySignalREvents>
  }

  const [useCurrenciesProvider, provideCurrenciesProvider] =
    createContext<CurrenciesDataSource>('currencies-provider')

  export { useCurrenciesProvider }
</script>
<script setup lang="ts">
  import { inject } from 'vue'
  import { useCurrencies } from '../../composables/useCurrencies'
  import { currenciesKey } from '@gat-ship/types/injection-keys'

  // The concrete `useCurrencies` result carries `signalR`; the injected
  // contract type omits it — narrow back to the concrete shape so the
  // provided context keeps `signalR` typed for `CurrenciesView`.
  const dataSource = (inject(currenciesKey, undefined) ??
    useCurrencies()) as CurrenciesDataSource
  provideCurrenciesProvider(dataSource)
  defineExpose({
    dataSource
  })
</script>
<template>
  <slot />
</template>
